import { useContext } from 'react';
import TranslationContext, {
  TranslationContextType,
} from '../context/TranslationContext';

const useTranslation = (): TranslationContextType => {
  return useContext(TranslationContext);
};

export default useTranslation;
